const ECGAnalysisSource = {
  EVERBEAT: 'everbeat',
  REFERENCE: 'reference',
} as const;

type ECGAnalysisSource = typeof ECGAnalysisSource[keyof typeof ECGAnalysisSource];

export { ECGAnalysisSource };
